import React from 'react';
import { motion } from 'framer-motion';
import { Lock, FileText, Send, PenTool, CheckCircle, Shield } from 'lucide-react';

const CircularFlow = () => {
  const icons = [
    { icon: <Lock className="w-6 h-6" />, label: "Login", color: "#6366f1" },
    { icon: <FileText className="w-6 h-6" />, label: "Upload", color: "#a855f7" },
    { icon: <PenTool className="w-6 h-6" />, label: "Sign", color: "#ec4899" },
    { icon: <Send className="w-6 h-6" />, label: "Send", color: "#22c55e" },
    { icon: <Shield className="w-6 h-6" />, label: "Verify", color: "#eab308" },
    { icon: <CheckCircle className="w-6 h-6" />, label: "Complete", color: "#3b82f6" },
  ];

  const radius = 140; // Radius of the circle

  return (
    <div className="relative w-[400px] h-[400px] flex items-center justify-center">
      {/* Central Pulse */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-32 h-32 bg-primary/20 rounded-full animate-ping absolute"></div>
        <div className="w-24 h-24 bg-dark border border-primary/50 rounded-full flex items-center justify-center z-10 shadow-[0_0_30px_rgba(99,102,241,0.5)]">
          <span className="text-2xl font-bold text-white">SignO</span>
        </div>
      </div>

      {/* Orbiting Icons */}
      <motion.div 
        className="absolute w-full h-full"
        animate={{ rotate: 360 }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
      >
        {icons.map((item, index) => {
          const angle = (index / icons.length) * 2 * Math.PI;
          const x = Math.cos(angle) * radius;
          const y = Math.sin(angle) * radius;

          return (
            <motion.div
              key={index}
              className="absolute top-1/2 left-1/2 w-16 h-16 -ml-8 -mt-8 bg-dark border border-white/10 rounded-full flex flex-col items-center justify-center shadow-lg"
              style={{ 
                x, 
                y,
                borderColor: item.color,
                boxShadow: `0 0 15px ${item.color}40`
              }}
              // Counter-rotate the icon so it stays upright
              animate={{ rotate: -360 }}
              transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            >
              <div style={{ color: item.color }}>{item.icon}</div>
              <span className="text-[10px] mt-1 font-semibold text-gray-300">{item.label}</span>
            </motion.div>
          );
        })}
      </motion.div>

      {/* Connecting Dashed Circle */}
      <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{ transform: 'rotate(-90deg)' }}>
        <circle 
          cx="200" 
          cy="200" 
          r={radius} 
          fill="none" 
          stroke="rgba(255,255,255,0.1)" 
          strokeWidth="2" 
          strokeDasharray="10 10"
        />
      </svg>
    </div>
  );
};

export default CircularFlow;
